import "./jquery-global.js";

import "paginationjs";
//import "paginationjs/dist/pagination.js";
import "paginationjs/dist/pagination.css";

import Handlebars from "handlebars";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

// handlebars templates
import propertyTemplate from "../../templates/property-template.hbs";
import popupTemplate from "../../templates/popup-template.hbs";

// main modules
import initMap from "./map/initMap";
import initSearch from "./search/form";
import initPagination from "./listings/pagination";

// main DOM elements
export const dataContainer = $("#listing-container");
export const paginationContainer = $("#pagination-container");
export const listingSection = document.getElementById("listing-section");
export const lang = document.documentElement.lang;
export const ajaxUrl = ajaxObject.ajax_url;
export const templates = { propertyTemplate, popupTemplate };

export function datasetHandler() {
    if (dataContainer) {
        window.regionCode = dataContainer.data("region");
        window.agentCode = dataContainer.data("agent");
        window.propertyTypeCode = dataContainer.data("type");
        window.municipalityCode = dataContainer.data("municipality");
    }
}

datasetHandler();

// initialize app
const map = initMap({ ajaxUrl, templates });
initSearch({ map, ajaxUrl, templates });
initPagination({ map, ajaxUrl, templates });

window.searchListings = (params) =>
    initPagination({ map, ajaxUrl, templates, forceParams: params });
